import {
  isValidIpv4Address,
  isValidIpv6Address,
} from 'utils/formValidation/validations';

export const getIpVersion = (addr: string): 'ipv4' | 'ipv6' | null => {
  if (isValidIpv4Address(addr)) {
    return 'ipv4';
  }
  if (isValidIpv6Address(addr)) {
    return 'ipv6';
  }
  return null;
};
